!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/models/sePlayPageMdl',[
      'lodash',
      'backboneMdl',
      'app/config/constants',
      'app/models/seSurveyElementMdl'
    ], factory)
  }
}(function (
  _,
  BackboneBase,
  CONSTANTS,
  seSurveyElementMdl
) {

  var LOG_LABEL = 'PlPAGE MDL'

  var STATUS = CONSTANTS.STATUS

  /*
      WORKAROUND FOR BAD \x \u encodings in session data
      Should be fixed in backend - for now we have those methods as workarounds --ab 2018-07-04
   */
  function decodeUnicode (str) {
    if (typeof str !== 'string') return str
    return str.replace(/\\u([a-f0-9]{4})/gi, function (n, hex) {
      return String.fromCharCode(parseInt(hex, 16))
    })
  }

  function decodeUtfHex (str) {
    if (typeof str !== 'string') return str
    return str.replace(/\\x([a-f0-9]{2})/gi, function (n, hex) {
      return String.fromCharCode(parseInt(hex, 16))
    })
  }

  function decodeURIObjectString (objectStr) {
    var os = objectStr.trim(),
      osCore, osArr //debugger;

    osCore = os.substr(2)
    osCore = osCore.substring(0, osCore.length - 2)

    osArr = osCore.split('","')

    osArr = osArr.map(function (val, idx) {
      var valArr = val.split('":"'),
        val0 = valArr[1]

      if (val0.match(/\\x/)) {
        val0 = decodeUtfHex(val0)
      }

      if (val0.match(/\\u/)) {
        val0 = decodeUnicode(val0)
      }

      valArr[1] = val0

      return valArr.join('":"')
    })

    osCore = osArr.join('","')

    return '{"' + osCore + '"}'
  }

  /*
   WORKAROUND methods end
   */

  var
    PlayPageElementsCollectionModel = BackboneBase.Collection.extend({
      // basics
      model: seSurveyElementMdl

    })

  /**
   * initialize by sending an object with
   * obj.id = pageId
   * obj.label = page label (optional)
   *
   * new SurveyPageModel({id: "p10", label: "page 10"})
   *
   * if page is only temporary
   * obj.isTemporary = true
   *
   * -> creates a new model and syncs automatically with the backend (if not temporary)
   *
   */

  var
      /**
       * @type PlayPageModel
       * @extends BackboneBaseModel
       */
    PlayPageModel = BackboneBase.Model.extend({
      // basics
      defaults: {
        cid: null,
        id: null,
        label: '',

        isActive: false,

        notDeletedElementsCount: 0,
        elementsOrder: null,

        hasValidationError: false,

        position: -1,
        beforePageId: null,

        randomgroup: null,

        jsml: null, // raw orig JSML object
        indexJsml: null, // raw orig Index JSML page object

        sessionData: null // retrieved in Page->Data-><cdata>
      },
      isParsing: false,
      isTemporary: false,
      elements: null, // placeholder for elements collection

      language: null,

      init: function (params, options) {
        var _this = this

        _this.set('cid', _this.cid)

        if (options && options.language) {
          _this.language = options.language
        }

        _this.elements = new PlayPageElementsCollectionModel()

        _this._readParams(params)

        _this.elements.on('sort update reset add remove status stati', function () {
          _this.cset('elementsOrder', _this.elements.getElementsOrder())
        })

      },

      _readParams: function (params) {
        var _this = this

        if (!params) {
          params = {
            isTemporary: true
          }
        }

        if (!params.id) {
          params.id = CONSTANTS.PREFIX_TEMPORARY + Math.round((Date.now() * Math.random()))
        }

        _this.setId(params.id)

        if (params.isTemporary) {
          _this.isTemporary = true

          _this.setStatus(STATUS.TEMPORARY)
        } else {
          _this.setStatus(STATUS.NOT_LOADED)
        }

        // set attributes that we are fine with
        _.forEach(params, function (val, param) {
          switch (param) {
            case 'id':
            case 'label':
            case 'position':
            case 'indexJsml':
            case 'beforePageId':
              _this.cset(param, val)
              break
            default:
              // all others - delete
              delete (_this.attributes[param])
              break
          }
        })

        if (params.pageJsml) {
          _this.parse(params.pageJsml)
        }
      },

      // read in
      parse: function (pageJsml, options) {
        var _this = this,
          _elements = _this.elements,
          ElementMdl = _this.elements.model

        //_this._changedSinceLastSave = false;

        if (!_.isArray(pageJsml) ||
          pageJsml[0] != 'Page') {
          // not a valid Page JSML - happens e.g. on createPage which returns an index.
          return
        }

        if (_this.status === STATUS.SAVING) {
          // dont parse in the new pageJsml from the server
          return
        }

        var _options = _.merge({
          playMode: false
        }, options || {})

        _this.cset('jsml', pageJsml)

        var serverTimestamp = Date.now(),
          tmpSElm,
          selmVals,
          newElements = [],
          hasChangedElements = false

        _elements.each(function (selmObj) {
          if (selmObj.status >= STATUS.LOADED
            && selmObj.status < STATUS.DELETED
            && selmObj.status !== STATUS.SAVING
            && selmObj.status !== STATUS.CHANGED) {
            selmObj.needsUpdate = true
          }
        })

        var
          elmPos = -1,
          type = null

        _.forEach(pageJsml, function (selmJsml, i) {
          // typeof page root = string
          // typeof page info = object
          // typeof element = array
          if (_.isArray(selmJsml)) {
            type = selmJsml[0].toLowerCase()

            switch (type) {
              case 'close_survey':
                if(_options.playMode){
                  // ignore certain elements in play
                  return;
                }
                break;
              case 'data': // data element, used in Play
                var dataRaw = _.last(selmJsml),
                  dataJson

                try {
                  dataJson = JSON.parse(dataRaw)

                } catch (err) {

                  console.warn(LOG_LABEL, 'bad encoded data element - trying to decode', err, selmJsml)

                  try {
                    dataRaw = decodeURIObjectString(dataRaw)
                    dataJson = JSON.parse(dataRaw)

                  } catch (err) {

                    dataJson = { error: err }
                    console.error(LOG_LABEL, 'bad encoded data element', err, dataRaw)

                  }
                }

                _this.cset('sessionData', dataJson)
                return

                break
            }

            var
              selmId = selmJsml[1].Id || selmJsml[1].id,
              selm = _elements.get(selmId)

            if (selm) {
              if (!selm.needsUpdate) {
                return
              }

              delete (selm.needsUpdate)

              selm.parse(selmJsml)
              selm.trigger('isLoaded')

            } else {
              selm = new ElementMdl({
                jsml: selmJsml
              }, {
                language: _this.language
              })

              selm.trigger('isLoaded')

              newElements.push(selm)
            }

            elmPos++
            selm.set('position', elmPos)

          }
        })

        if (newElements.length) {
          _elements.add(newElements) // automatically triggers a re-sort
        } else {
          _elements.sort()
        }

        var deleteElements = []
        _elements.each(function (selmObj) {
          if (selmObj.needsUpdate) {
            // if element was not updated it can now be deleted because
            // the new page does not have it in it.
            selmObj.setDeleted()
          }
        })

        _this.set('notDeletedElementsCount', _this.elements.getNotDeletedElementsCount())
        _this.set('hasValidationError', _this.hasElementWithValidationError())

        if (hasChangedElements) {
          _this.trigger('hasChanged')
        }

      },

      hasElementWithValidationError: function () {
        var _this = this

        return !_.reduce(_this.elements.models, function (hasNoValError, elm) {
          return hasNoValError && (!elm.getValidationError() || elm.isDeleted)
        }, true)
      },

      // write out

      _changedSinceLastSave: true,
      _latestJsml: null,
      toJsml: function (onlyIfChanged) {
        var _this = this,
          _elements = _this.elements

        if (_this.status != STATUS.CHANGED) {
          if (onlyIfChanged) {
            return false
          }

          if (_this._latestJsml) {
            return _this._latestJsml
          }
        }

        // else -> status == CHANGED

        if (_this.isTemporary) {
          console.warn(LOG_LABEL, 'page out', 'page is only temporary', _this.id)
          return
        }

        var
          newPageJsml = ['Page'],
          pageAttributes = _this.pget('jsml.1') || {}

        newPageJsml.push(pageAttributes)

        _elements.forEach(function (selmObj) {
          if (selmObj.isDeleted ||
            selmObj.isTemporary) {
            return
          }

          newPageJsml.push(selmObj.toJsml({
            triggerIsSaving: true
          }))
        })

        _this._latestJsml = _.cloneDeep(newPageJsml)

        return newPageJsml
      },

      toSimpleJsml: function () {
        var _this = this

        if (_this.isTemporary) {
          console.warn(LOG_LABEL, 'toSimpleJsml', 'aborted; page is only temporary', _this.id)
          return
        }

        var newSimplePageJsml = ['Page'],
          indexJsml = _this.cget('indexJsml'),
          attributes

        if (!indexJsml) {
          /*
           <Page Id='P2' Display_Label='Introduction' Filename='PageP2.xml'/>
           */
          indexJsml = ['Page', {
            Id: _this.id,
            Display_Label: '',
            Filename: 'Page' + _this.id + '.xml'
          }]
        }
        attributes = indexJsml[1]

        attributes.Id = _this.id
        attributes.Filename = 'Page' + _this.id + '.xml'
        attributes.Display_Label = _this.get('label')

        newSimplePageJsml.push(attributes)

        _this.set('indexJsml', indexJsml)

        return newSimplePageJsml
      },

      // actions

      setId: function (newId) {
        var _this = this

        _this.oldId = _this.id
        _this.id = newId

        if (_this.collection) {
          _this.collection._updateIdReference(_this.oldId, newId)
        }

        _this.set('id', newId)
      },

      translate: function (languageMdl) {
        var _this = this

        _.each(_this.elements.models, function (elmMdl) {
          elmMdl.translate(languageMdl)
        })

        _this.trigger('translated')
      }

    })

  return PlayPageModel

});
